import { render } from "./Transaction.vue?vue&type=template&id=7c6a6d2a&scoped=true&ts=true"
import script from "./Transaction.vue?vue&type=script&lang=ts"
export * from "./Transaction.vue?vue&type=script&lang=ts"

import "./Transaction.vue?vue&type=style&index=0&id=7c6a6d2a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6a6d2a"]])

export default __exports__